import { connect } from 'react-redux';
import OutOfStockReportComponent from './OutOfStockReportComponent';
import { outOfStockReportOperations } from './duck';
import { dashboardOperations } from '../../../duck';

const mapStateToProps = (state) => {
    return {
        ...state,
        login: state.login
    }
};

const mapDispatchToProps = (dispatch) => {
    const updateTitle = (title) => dispatch(dashboardOperations.updateTitle(title));
    const getOutOfStock = (onDate) => dispatch(outOfStockReportOperations.getOutOfStock(onDate));    
    return {
        updateTitle, 
        getOutOfStock
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OutOfStockReportComponent)